import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

const resolveBaseUrl = (): string => {
  const fromWindow = (window as typeof window & { __DOCUMENT_SIGN_API_BASE_URL__?: string })
    .__DOCUMENT_SIGN_API_BASE_URL__;

  return fromWindow?.trim() || environment.apiBaseUrl;
};

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: resolveBaseUrl,
});
